import { createRoot } from "react-dom/client";
import { initSentry } from "./lib/sentry";
import App from "./App";
import "./index.css";

// Initialise Sentry before React mounts so even very-early render errors
// are captured. No-op when VITE_SENTRY_DSN_FRONTEND is not configured.
initSentry();

createRoot(document.getElementById("root")!).render(<App />);
